import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import './css/global.css';
import Homepage from './pages/Homepage';
import Countries from './pages/Countries';
import Staffingsubpage from './pages/Staffingsubpage';
import CompaniesHiring from './pages/CompaniesHiring';
import Contractors from './pages/Contractors';
import Careers from './pages/Careers';
import Platform from './pages/Platform';
import Experts from './pages/Experts';
import EOR from './pages/EOR';
import Contingent from './pages/Contingent';/* 
import Partnerships from './pages/Partnerships'; */
import Footer from './components/Footer';
import Country from './pages/Country';
import PayrollPage from './pages/PayrollPage';
import EORcalculation from './pages/EORcalculation';
import CurrentVacancies from './pages/CurrentVacancies';
import StaffingEOR from './pages/StaffingEOR';
import StaffingIndependent from './pages/StaffingIndependent';
import Contactus from './pages/Contactus';


const App = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="countries" element={<Countries />} />
        <Route path="staffing-and-recruitment-firms" element={<Staffingsubpage />} />
        <Route path='companies-hiring-internationally' element={<CompaniesHiring />} />
        <Route path='contractors' element={<Contractors />} />
        <Route path='careers' element={<Careers />} />
        <Route path='workforce-management-technology' element={<Platform />} />
        <Route path='meet-the-experts' element={<Experts />} />
        <Route path='companies-hiring-internationally/global-employer-of-record' element={<EOR />} />
        <Route path='companies-hiring-internationally/contingent-workforce-management' element={<Contingent />} />
        <Route path='staffing-and-recruitment-firms/employer-of-record-for-recruitment-firms' element={<StaffingEOR />} />
        <Route path='staffing-and-recruitment-firms/independent-contractor-management' element={<StaffingIndependent />} />
        <Route path='/current-vacancies' element={<CurrentVacancies />} />
        <Route path='payroll' element={<PayrollPage />} />
        <Route path='country/:item' element={<Country />} />
        <Route path='/country/:countryName/cost-calculator' element={<EORcalculation />} />
        <Route path='/contact-us' element={<Contactus />} />
       
        
      </Routes>
      <Footer/>
    </Router>
  );
};

export default App;
